import { useRestClient } from '@/contexts/QueryProvider'
import { useState } from 'react'
import { toast } from 'sonner'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { IconDeleteOutline } from '@icons/IconDeleteOutline'
import { Button } from '@/components/shadcn/button'
import { ApplicationRoleItem } from '../AppRolesPage'

export function DeleteAppRoleConfirmDialog({ role }: { role: ApplicationRoleItem }) {
  const [isOpen, setIsOpen] = useState(false)

  const { deleteApplicationsApiDeleteApplicationRole, getApplicationsApiListApplicationRoles } = useRestClient()
  const { mutate: deleteAppRole, isPending } = deleteApplicationsApiDeleteApplicationRole.useMutation()

  const handleDelete = () => {
    deleteAppRole(
      {
        query: {
          applicationId: role.applicationId,
          roleId: role.id,
        },
      },
      {
        onSuccess: () => {
          toast.success('Application role successfully deleted')
          setIsOpen(false)
          getApplicationsApiListApplicationRoles.invalidateQueries({
            parameters: {
              query: { applicationId: role.applicationId },
            },
          })
        },
        onError: () => {
          toast.error('Error deleting application role')
        },
      }
    )
  }

  return (
    <ConfirmDialog
      trigger={
        <Button size="icon" variant="ghost" aria-label="Delete role">
          <IconDeleteOutline className="size-4" />
        </Button>
      }
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      title="Delete role"
      description={`Are you sure you want to delete the role "${role.name.value}"?`}
      confirmLabel="Delete"
      confirmVariant="destructive"
      onConfirm={handleDelete}
      closeOnConfirm={false}
      isSubmitting={isPending}
    />
  )
}
